/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';

export default function OwnerOnboardingPage({ onNavigate, ownerId }) {
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [owner, setOwner] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', phone: '' });
  const [accountCreated, setAccountCreated] = useState(false);
  const [stripeConnected, setStripeConnected] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!ownerId) return;
    supabase.from('property_owners').select('*').eq('id', ownerId).single()
      .then(({ data }) => {
        if (data) {
          setOwner(data);
          setForm({ name: data.full_name || '', email: data.email || '', phone: data.phone || '' });
          if (data.stripe_onboarded) setStripeConnected(true);
        }
      });

    // Detecter retour Stripe success
    const params = new URLSearchParams(window.location.search);
    if (params.get('stripe') === 'success') {
      supabase.from('property_owners').update({
        stripe_onboarded: true,
        updated_at: new Date().toISOString(),
      }).eq('id', ownerId).then(() => {
        setStripeConnected(true);
        setStep(2);
      });
    }
  }, [ownerId]);

  const update = (key, val) => setForm(function(f) { return Object.assign({}, f, { [key]: val }); });

  const handleCreateAccount = async function() {
    if (!form.name || !form.email) { setError('Nom et email requis.'); return; }
    setLoading(true);
    setError(null);
    try {
      await supabase.from('property_owners').update({
        full_name: form.name,
        email: form.email,
        phone: form.phone,
        updated_at: new Date().toISOString(),
      }).eq('id', ownerId);
      setAccountCreated(true);
      setStep(1);
    } catch (e) {
      setError('Erreur : ' + e.message);
    } finally {
      setLoading(false);
    }
  };

  const handleConnectStripe = async function() {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/api/stripe-connect-onboarding', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ownerId: ownerId,
          email: form.email,
          ownerName: form.name,
          returnUrl: window.location.origin + '/?page=owner-onboarding&owner_id=' + ownerId + '&stripe=success',
          refreshUrl: window.location.origin + '/?page=owner-onboarding&owner_id=' + ownerId,
        }),
      });
      const data = await response.json();
      if (data.url) {
        window.open(data.url, '_blank');
      } else {
        setError('Erreur Stripe : ' + (data.error || 'Reessayez.'));
      }
    } catch (e) {
      setError('Erreur de connexion. Reessayez.');
    } finally {
      setLoading(false);
    }
  };

  var inputStyle = { width: '100%', padding: '10px 14px', border: '1px solid #e0e0e0', borderRadius: 10, fontSize: 14, fontFamily: 'sans-serif', outline: 'none', color: '#1A1A18', background: '#fff', transition: 'border-color 0.15s', boxSizing: 'border-box' };
  var labelStyle = { fontSize: 13, fontWeight: 500, color: '#555', display: 'block', marginBottom: 6 };

  var STEPS = ['Mon profil', 'Connecter Stripe', 'Confirmation'];

  return (
    <div style={{ minHeight: '100vh', background: '#F7F7F5', padding: '80px 1rem 2rem' }}>
      <div style={{ maxWidth: 520, margin: '0 auto' }}>

        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 32, fontStyle: 'italic', letterSpacing: '-1px', marginBottom: 8 }}>
            haven<span style={{ color: '#1D9E75' }}>ly</span>
          </div>
          <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 22, letterSpacing: '-0.5px', margin: '0 0 8px' }}>
            Bienvenue, proprietaire
          </h1>
          <p style={{ fontSize: 14, color: '#777', lineHeight: 1.6, margin: 0 }}>
            Configurez votre compte pour recevoir vos revenus directement, en toute transparence.
          </p>
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
          {STEPS.map(function(s, i) {
            return (
              <div key={s} style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
                  <div style={{ width: 32, height: 32, borderRadius: '50%', background: i < step ? '#1D9E75' : step === i ? '#1A1A18' : '#e0e0e0', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 500 }}>
                    {i < step ? '+' : i + 1}
                  </div>
                  <div style={{ fontSize: 11, color: step === i ? '#1A1A18' : '#999', fontWeight: step === i ? 500 : 400, whiteSpace: 'nowrap' }}>{s}</div>
                </div>
                {i < STEPS.length - 1 && (
                  <div style={{ width: 60, height: 1, background: i < step ? '#1D9E75' : '#e0e0e0', margin: '0 8px', marginBottom: 20 }} />
                )}
              </div>
            );
          })}
        </div>

        {error && (
          <div style={{ background: '#FCEBEB', border: '1px solid #F09595', borderRadius: 10, padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#A32D2D' }}>
            {error}
          </div>
        )}

        {step === 0 && (
          <div style={{ background: '#fff', border: '1px solid #e8e8e4', borderRadius: 16, padding: 28 }}>
            <h2 style={{ fontSize: 16, fontWeight: 500, marginBottom: 6 }}>Vos informations</h2>
            <p style={{ fontSize: 13, color: '#777', marginBottom: 20, lineHeight: 1.6 }}>
              Ces informations permettront a Havenly de vous identifier et de vous reverser vos revenus.
            </p>
            <div style={{ background: '#F0FAF6', border: '1px solid #1D9E75', borderRadius: 12, padding: '14px 16px', marginBottom: 20 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#0F6E56', marginBottom: 6 }}>Reversement automatique Havenly</div>
              <p style={{ fontSize: 12, color: '#0F6E56', lineHeight: 1.65, margin: 0 }}>
                Une fois votre compte Stripe connecte, vous recevrez votre part directement a chaque reservation.
              </p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <div>
                <label style={labelStyle}>Prenom et nom *</label>
                <input style={inputStyle} placeholder="Jean Dupont" value={form.name}
                  onChange={function(e) { update('name', e.target.value); }}
                  onFocus={function(e) { e.target.style.borderColor = '#1D9E75'; }}
                  onBlur={function(e) { e.target.style.borderColor = '#e0e0e0'; }} />
              </div>
              <div>
                <label style={labelStyle}>Email *</label>
                <input style={inputStyle} type="email" placeholder="jean@exemple.fr" value={form.email}
                  onChange={function(e) { update('email', e.target.value); }}
                  onFocus={function(e) { e.target.style.borderColor = '#1D9E75'; }}
                  onBlur={function(e) { e.target.style.borderColor = '#e0e0e0'; }} />
              </div>
              <div>
                <label style={labelStyle}>Telephone (optionnel)</label>
                <input style={inputStyle} type="tel" placeholder="+33 6 12 34 56 78" value={form.phone}
                  onChange={function(e) { update('phone', e.target.value); }}
                  onFocus={function(e) { e.target.style.borderColor = '#1D9E75'; }}
                  onBlur={function(e) { e.target.style.borderColor = '#e0e0e0'; }} />
              </div>
            </div>
            <button onClick={handleCreateAccount} disabled={loading}
              style={{ width: '100%', padding: '13px', background: loading ? '#ccc' : '#1D9E75', color: '#fff', border: 'none', borderRadius: 24, fontSize: 14, fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'sans-serif', marginTop: 24 }}>
              {loading ? 'Enregistrement...' : 'Continuer'}
            </button>
          </div>
        )}

        {step === 1 && (
          <div style={{ background: '#fff', border: '1px solid #e8e8e4', borderRadius: 16, padding: 28 }}>
            <h2 style={{ fontSize: 16, fontWeight: 500, marginBottom: 6 }}>Connecter votre compte bancaire</h2>
            <p style={{ fontSize: 13, color: '#777', marginBottom: 20, lineHeight: 1.6 }}>
              Havenly utilise Stripe pour verser vos revenus directement sur votre compte bancaire. La connexion prend 2 minutes.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
              {[
                { icon: '🔒', title: 'Securise', desc: 'Stripe est utilise par des millions d\'entreprises dans le monde' },
                { icon: '⚡', title: 'Virement rapide', desc: 'Vos revenus sont vires 24h apres le check-in de chaque voyageur' },
                { icon: '📊', title: 'Tableau de bord', desc: 'Suivez tous vos virements depuis votre espace Stripe' },
              ].map(function(item) {
                return (
                  <div key={item.title} style={{ display: 'flex', gap: 12, padding: '12px 14px', background: '#F7F7F5', borderRadius: 10 }}>
                    <span style={{ fontSize: 20, flexShrink: 0 }}>{item.icon}</span>
                    <div>
                      <div style={{ fontSize: 13, fontWeight: 500, color: '#1A1A18', marginBottom: 2 }}>{item.title}</div>
                      <div style={{ fontSize: 12, color: '#777', lineHeight: 1.5 }}>{item.desc}</div>
                    </div>
                  </div>
                );
              })}
            </div>
            {stripeConnected ? (
              <div style={{ background: '#F0FAF6', border: '1px solid #1D9E75', borderRadius: 12, padding: '16px', textAlign: 'center', marginBottom: 20 }}>
                <div style={{ fontSize: 24, marginBottom: 8 }}>+</div>
                <div style={{ fontSize: 14, fontWeight: 500, color: '#0F6E56' }}>Stripe connecte avec succes !</div>
              </div>
            ) : (
              <button onClick={handleConnectStripe} disabled={loading}
                style={{ width: '100%', padding: '13px', background: loading ? '#ccc' : '#635BFF', color: '#fff', border: 'none', borderRadius: 24, fontSize: 14, fontWeight: 500, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'sans-serif', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10, marginBottom: 12 }}>
                {loading ? 'Redirection...' : 'Connecter mon compte bancaire'}
              </button>
            )}
            <div style={{ display: 'flex', gap: 10 }}>
              {stripeConnected && (
                <button onClick={function() { setStep(2); }}
                  style={{ flex: 1, padding: '11px', background: '#1D9E75', color: '#fff', border: 'none', borderRadius: 24, fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: 'sans-serif' }}>
                  Continuer
                </button>
              )}
              <button onClick={function() { setStep(2); }}
                style={{ flex: 1, padding: '11px', background: 'transparent', color: '#777', border: '1px solid #e0e0e0', borderRadius: 24, fontSize: 14, cursor: 'pointer', fontFamily: 'sans-serif' }}>
                Passer pour l'instant
              </button>
            </div>
            <p style={{ fontSize: 11, color: '#aaa', textAlign: 'center', marginTop: 12 }}>
              Vous pourrez connecter Stripe plus tard depuis votre espace proprietaire.
            </p>
          </div>
        )}

        {step === 2 && (
          <div style={{ background: '#fff', border: '1px solid #e8e8e4', borderRadius: 16, padding: 28, textAlign: 'center' }}>
            <div style={{ width: 72, height: 72, borderRadius: '50%', background: '#F0FAF6', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: 32 }}>
              +
            </div>
            <h2 style={{ fontFamily: 'Georgia,serif', fontSize: 22, letterSpacing: '-0.5px', marginBottom: 12 }}>
              Votre compte est configure !
            </h2>
            <p style={{ fontSize: 14, color: '#777', lineHeight: 1.7, marginBottom: 24 }}>
              {stripeConnected
                ? 'Vous recevrez vos revenus directement sur votre compte bancaire a chaque reservation.'
                : 'Votre profil est cree. Connectez Stripe quand vous etes pret pour recevoir vos revenus.'}
            </p>
            <div style={{ background: '#F7F7F5', borderRadius: 12, padding: '16px 20px', marginBottom: 24, textAlign: 'left' }}>
              <div style={{ fontSize: 13, fontWeight: 500, color: '#1A1A18', marginBottom: 10 }}>Recapitulatif</div>
              {[
                { label: 'Nom', val: form.name },
                { label: 'Email', val: form.email },
                { label: 'Stripe', val: stripeConnected ? 'Connecte' : 'En attente' },
              ].map(function(row) {
                return (
                  <div key={row.label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, padding: '6px 0', borderBottom: '1px solid #e8e8e4' }}>
                    <span style={{ color: '#777' }}>{row.label}</span>
                    <span style={{ color: row.val === 'Connecte' ? '#1D9E75' : row.val === 'En attente' ? '#C4784A' : '#1A1A18', fontWeight: 500 }}>{row.val}</span>
                  </div>
                );
              })}
            </div>
            {!stripeConnected && (
              <button onClick={function() { setStep(1); }}
                style={{ width: '100%', padding: '12px', background: '#635BFF', color: '#fff', border: 'none', borderRadius: 24, fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: 'sans-serif', marginBottom: 12 }}>
                Connecter Stripe maintenant
              </button>
            )}
            <button onClick={function() { onNavigate('home'); }}
              style={{ width: '100%', padding: '12px', background: 'transparent', color: '#777', border: '1px solid #e0e0e0', borderRadius: 24, fontSize: 14, cursor: 'pointer', fontFamily: 'sans-serif' }}>
              Retour a l'accueil
            </button>
            <p style={{ fontSize: 12, color: '#aaa', marginTop: 16, lineHeight: 1.6 }}>
              Des questions ? <a href="mailto:contact@havenly.fr" style={{ color: '#1D9E75' }}>contact@havenly.fr</a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
